var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/Grid/Grid.jinja"] = require( "front/components/Grid/Grid.jinja" );
dependencies["front/components/TopNav/TopNav.jinja"] = require( "front/components/TopNav/TopNav.jinja" );
dependencies["front/components/Slider/SliderVariant.jinja"] = require( "front/components/Slider/SliderVariant.jinja" );
dependencies["front/components/Video/Video.jinja"] = require( "front/components/Video/Video.jinja" );
dependencies["front/components/BuildingCross/BuildingCross.jinja"] = require( "front/components/BuildingCross/BuildingCross.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Production/Production.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/Production/Production.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Production/Production.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "svgSprite")) {
var t_7 = t_4.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_7);
output += "\n\n";
env.getTemplate("front/components/Grid/Grid.jinja", false, "assets/app/front/pages/Production/Production.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "Grid")) {
var t_11 = t_8.Grid;
} else {
cb(new Error("cannot import 'Grid'")); return;
}
context.setVariable("Grid", t_11);
output += "\n";
env.getTemplate("front/components/TopNav/TopNav.jinja", false, "assets/app/front/pages/Production/Production.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "TopNav")) {
var t_15 = t_12.TopNav;
} else {
cb(new Error("cannot import 'TopNav'")); return;
}
context.setVariable("TopNav", t_15);
output += "\n";
env.getTemplate("front/components/Slider/SliderVariant.jinja", false, "assets/app/front/pages/Production/Production.jinja", false, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
t_16.getExported(function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
if(Object.prototype.hasOwnProperty.call(t_16, "SliderVariant")) {
var t_19 = t_16.SliderVariant;
} else {
cb(new Error("cannot import 'SliderVariant'")); return;
}
context.setVariable("SliderVariant", t_19);
output += "\n";
env.getTemplate("front/components/Video/Video.jinja", false, "assets/app/front/pages/Production/Production.jinja", false, function(t_21,t_20) {
if(t_21) { cb(t_21); return; }
t_20.getExported(function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
if(Object.prototype.hasOwnProperty.call(t_20, "Video")) {
var t_23 = t_20.Video;
} else {
cb(new Error("cannot import 'Video'")); return;
}
context.setVariable("Video", t_23);
output += "\n";
env.getTemplate("front/components/BuildingCross/BuildingCross.jinja", false, "assets/app/front/pages/Production/Production.jinja", false, function(t_25,t_24) {
if(t_25) { cb(t_25); return; }
t_24.getExported(function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
if(Object.prototype.hasOwnProperty.call(t_24, "BuildingCross")) {
var t_27 = t_24.BuildingCross;
} else {
cb(new Error("cannot import 'BuildingCross'")); return;
}
context.setVariable("BuildingCross", t_27);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
output += t_28;
output += "\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("ogtitle"))(env, context, frame, runtime, function(t_31,t_30) {
if(t_31) { cb(t_31); return; }
output += t_30;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("topNav"))(env, context, frame, runtime, function(t_33,t_32) {
if(t_33) { cb(t_33); return; }
output += t_32;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_35,t_34) {
if(t_35) { cb(t_35); return; }
output += t_34;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 10;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += " • ";
output += runtime.suppressValue((lineno = 10, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Производство"])), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_ogtitle(env, context, frame, runtime, cb) {
var lineno = 11;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += " • ";
output += runtime.suppressValue((lineno = 11, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Производство"])), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_topNav(env, context, frame, runtime, cb) {
var lineno = 13;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    ";
output += runtime.suppressValue((lineno = 14, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "TopNav"), "TopNav", context, [runtime.makeKeywordArgs({"classes": "TopNav--fixed TopNav--production","currentUrl": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"path")})])), env.opts.autoescape);
output += "\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 17;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"Production\">\n        <div class=\"Production-floatNav\"></div>\n        <div class=\"Production-header\">\n            <div class=\"Production-subtitle\">\n                <span class=\"Production-subtitleStroke\"></span>\n                <div class=\"Production-subtitleText\">";
output += runtime.suppressValue((lineno = 23, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Производство"])), env.opts.autoescape);
output += "</div>\n            </div>\n            <div class=\"Production-description\">\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionPage")),"title"), env.opts.autoescape);
output += "\n            </div>\n        </div>\n        <div class=\"Production-aerialView\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            <svg class=\"Production-aerialViewSvg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1440 810\">\n                <path class=\"Production-aerialViewPath\" data-id=\"background\" d=\"M0,1v810h1440V1H0z M281.6,207.3l-3.6-10.1h6.4v-4.8l11-0.4l0.6,4.2h4.6l2.3,10.3L281.6,207.3z\n\t M1179.2,810.6h-147l17.8-27l14.2,2.8l3.3-5.5l1-26.3l27.5-40.5l2.4-43.9c1.1-3.6,2.6-5.8,4.5-6.7c8.6-4.1,17-3.3,19.7-3.3\n\tc2.4,0,9.6,0.3,15.7,3.3c3.6,1.7,8.5,5.4,10.1,8.3l-2.1,47.4L1210,730l0.8,26.8L1179.2,810.6z M1302.5,416.3l-17,6.2\n\tc-2.2-3.2-8.2-7.2-14-5.4s-67.3,24.6-67.3,24.6s-94.8,35.1-96.5,35.7c-1.7,0.6-21.2,9.1-23.5,10.4c-2.3,1.3-3.6,7.6-3.6,7.6\n\tl-28.8-3.4L768.4,389.3l-6,2.8L514,301.6V280l7.3-2.1l-18.2-5.2l0.1-4.3l-14.2-4.7l-26,6.7l-1.1-1.1l-15.3,2.9l-1.9,2.3v2l-18.3,4.4\n\tl-0.7,3l-3-1l-7.4,1.6l-4.4-0.5l-7.3,2.2l-6.2-2l-16.4,3.3l-57-40l-0.1-36l104.9-20.9l3.2-0.6v-11.8L558.6,152l10.8,3.2L698.2,129\n\tl125,31.9v45l55.5-13.8l231,60.8l4.1,4.1l16.3,5.2v11.4l5.2,1.1l0.3,7h3.8v6.7l-39,10.8l-12.3-3.5l-6.5,2.3v7.5l-16.5,4l74,20.8\n\tl106.6,30.4l58.6,18.4L1302.5,416.3z\"/>\n                <polygon class=\"Production-aerialViewPath\" data-id=\"1\" points=\"300.7,196.2 303,206.5 281.6,207.3 278,197.2 284.4,197.2 284.4,192.4 295.4,192 296,196.2\n                    \"/>\n                <polygon class=\"Production-aerialViewPath\" data-id=\"2\" points=\"431.9,190 323.9,211.4 323.9,247.7 380.9,287.8 397.3,284.4 403.5,286.4 405.4,286\n                    410.8,284.3 415.2,284.7 422.6,283.1 425.5,284.1 426.5,283.9 426.2,281.2 444.6,276.7 444.6,274.7 446.5,274.6 446.5,272.4\n                    461.9,269.5 463,270.7 489.3,263.9 489.3,253.3 490.2,252.7 490.2,240.7 546,227.4 546,223 527.5,218.2 527.4,206.9 498.4,200\n                    475.9,205.6 \"/>\n                <polygon class=\"Production-aerialViewPath\" data-id=\"3\" points=\"431.9,190.4 431.9,178.2 558.5,152 569.6,155.3 498.5,169.8 498.5,200.3 476,206 \"/>\n                <polygon class=\"Production-aerialViewPath\" data-id=\"4\" points=\"545.6,227.6 489.8,240.9 489.8,252.9 488.9,253.5 488.9,264.1 503.2,268.7 503.1,272.9\n                    521.3,278.2 724.4,230.4 724.4,224.5 680.5,213 576.4,236.9 \"/>\n                <polygon class=\"Production-aerialViewPath\" data-id=\"5\" points=\"497.9,169.7 497.9,200.3 526.9,207.3 527.1,218.6 545.5,223.3 545.5,227.7 576.3,237\n                    680.4,213.1 724.3,224.7 724.3,230.6 823.2,205.3 823.2,160.9 698.1,129 \"/>\n                <polygon class=\"Production-aerialViewPath\" data-id=\"6\" points=\"513.9,301.6 762.3,392.1 768.3,389.3 768.3,381.5 764.5,380.1 764.6,353.5 993.3,288.3\n                    1064.3,309.6 1081.5,305.3 1081.5,297.8 1080,297.7 1088,295.5 1100.3,299 1139.3,288.3 1139.3,281.6 1135.5,281.6 1135.1,274.6\n                    1130,273.5 1130,262.1 1113.7,256.8 1109.6,252.8 878.6,192 724.3,230.5 513.9,280 \"/>\n                <path class=\"Production-aerialViewPath\" data-id=\"7\" d=\"M1051.8,492l28.8,3.4c0,0,1.3-6.3,3.6-7.6c2.3-1.3,21.8-9.8,23.5-10.4\n                    c1.7-0.6,96.5-35.7,96.5-35.7s61.5-22.8,67.3-24.6c5.8-1.8,11.8,2.2,14,5.4l17-6.2l1.8-37.2l-58.6-18.4l-106.6-30.4l-97.3-27.4\n                    l-48-14.8l-228.7,65.2l-0.1,26.6l3.7,1.4v7.8L1051.8,492z\"/>\n                <path class=\"Production-aerialViewPath\" data-id=\"8\" d=\"M1098.4,670.1c1.1-3.6,2.6-5.8,4.5-6.7c8.6-4.1,17-3.3,19.7-3.3c2.4,0,9.6,0.3,15.7,3.3\n                    c3.6,1.7,8.5,5.4,10.1,8.3l-2.1,47.4L1210,730l0.8,26.8l-31.6,53.8h-147l17.8-27l14.2,2.8l3.3-5.5l1-26.3l27.5-40.5L1098.4,670.1z\"\n                    />\n            </svg>\n            <img class=\"Production-aerialViewImg\"\n            src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionAerialView")),"img")),"w1024"), env.opts.autoescape);
output += "\"\n            srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionAerialView")),"img")),"w1024"), env.opts.autoescape);
output += " 1024w,\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionAerialView")),"img")),"w1280"), env.opts.autoescape);
output += " 1280w,\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionAerialView")),"img")),"w1440"), env.opts.autoescape);
output += " 1440w,\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionAerialView")),"img")),"w1920"), env.opts.autoescape);
output += " 1920w\"\n            sizes=\"calc((540 / 1440) * 100vw)\"\n            alt=\"\">\n            ";
frame = frame.push();
var t_38 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionPage")),"factory");
if(t_38) {t_38 = runtime.fromIterator(t_38);
var t_37 = t_38.length;
for(var t_36=0; t_36 < t_38.length; t_36++) {
var t_39 = t_38[t_36];
frame.set("f", t_39);
frame.set("loop.index", t_36 + 1);
frame.set("loop.index0", t_36);
frame.set("loop.revindex", t_37 - t_36);
frame.set("loop.revindex0", t_37 - t_36 - 1);
frame.set("loop.first", t_36 === 0);
frame.set("loop.last", t_36 === t_37 - 1);
frame.set("loop.length", t_37);
output += "\n                ";
output += runtime.suppressValue((lineno = 69, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "BuildingCross"), "BuildingCross", context, [runtime.makeKeywordArgs({"dataId": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"),"state": "","header": runtime.memberLookup((t_39),"title"),"description": runtime.memberLookup((t_39),"description"),"caller": (function (){var macro_t_40 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_41 = "";;
frame = frame.pop();
return new runtime.SafeString(t_41);
});
return macro_t_40;})()})])), env.opts.autoescape);
output += "\n            ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n        <div class=\"Production-contents\">\n            <div class=\"Production-contentsHeader\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                <div class=\"Production-contentsStroke\"></div>\n            </div>\n            <div class=\"Production-contentsColumns\">\n                <div class=\"Production-contentsLeft\">\n                    <div class=\"Production-contentsText\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productionPage")),"text"), env.opts.autoescape);
output += "\n                    </div>\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "productionSlides")) {
output += "<div class=\"Production-contentsSlider\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                        ";
output += runtime.suppressValue((lineno = 83, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SliderVariant"), "SliderVariant", context, [runtime.makeKeywordArgs({"slides": runtime.contextOrFrameLookup(context, frame, "productionSlides"),"classes": "Slider--production"})])), env.opts.autoescape);
output += "\n                    </div>";
;
}
output += "\n                </div>\n                <div class=\"Production-contentsRight\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"200\">\n                    ";
frame = frame.push();
var t_44 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "f")),"title")?runtime.contextOrFrameLookup(context, frame, "productionFacts"):"");
if(t_44) {t_44 = runtime.fromIterator(t_44);
var t_43 = t_44.length;
for(var t_42=0; t_42 < t_44.length; t_42++) {
var t_45 = t_44[t_42];
frame.set("f", t_45);
frame.set("loop.index", t_42 + 1);
frame.set("loop.index0", t_42);
frame.set("loop.revindex", t_43 - t_42);
frame.set("loop.revindex0", t_43 - t_42 - 1);
frame.set("loop.first", t_42 === 0);
frame.set("loop.last", t_42 === t_43 - 1);
frame.set("loop.length", t_43);
output += "\n                        <div class=\"Production-contentsRightHeader\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_45),"title"), env.opts.autoescape);
output += "\n                        </div>\n                        <div class=\"Production-contentsRightDescription\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_45),"description"), env.opts.autoescape);
output += "\n                        </div>\n                    ";
;
}
}
frame = frame.pop();
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n                </div>\n            </div>\n        </div>\n        <div class=\"Production-media\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n            <video id=\"video\" class=\"Production-mediaVideo\" autoplay muted loop>\n                <source src=\"";
output += runtime.suppressValue((lineno = 126, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["video/production-bg.mp4"])), env.opts.autoescape);
output += "\">\n                Your browser does not support the video tag.\n            </video>\n            <div class=\"Production-mediaTexts\">\n                <div class=\"Production-mediaTitle\">\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 131, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Самая быстрая линия розлива работает со&nbsp;скоростью 90&nbsp;000&nbsp;банок&nbsp;в&nbsp;час"]))), env.opts.autoescape);
output += "\n                </div>\n";
output += "\n";
output += "\n";
output += "\n            </div>\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_ogtitle: b_ogtitle,
b_topNav: b_topNav,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Production/Production.jinja"] , dependencies)